import React from 'react'
import { LineChart, XAxis, YAxis, CartesianGrid, ResponsiveContainer, ReferenceLine} from "recharts";

const timeFormatter = (n) =>new Date(n).toLocaleString('en-GB', {hour:'2-digit', minute:'2-digit' })

export default function ChartPadder({height,xTicks,xLines}) {
    return (
        <ResponsiveContainer width="100%" height={height} >
            <LineChart data={[]} margin={{right: 30, left: 150}}>
                <XAxis dataKey="time" type="number" ticks={xTicks} domain={[xTicks[0],xTicks[12]]} hide={true} tickFormatter={timeFormatter} />
                <YAxis  />
                <CartesianGrid strokeDasharray="3 3"/>
                {xLines.map(time=><ReferenceLine key={time} x={time} stroke="#636E72"/>)}
            </LineChart>
        </ResponsiveContainer>
    )
}
